import styled from 'styled-components';

import { Color } from '../../../../constants/Colors';

export const RootNav = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  h5 {
    color: ${Color.BLUE_RIBBON};
  }
`;

export const LogoLink = styled.a`
  border: 2px solid transparent;
  border-radius: 4px;

  &:focus {
    border: 2px solid ${Color.CLOUD_BURST};
    outline: 0px;
  }
`;

export const Logo = styled.img`
  width: initial;
  height: 30px;
  padding-right: 15px;
  outline: 0px;
`;
